import { Component, inject, signal, ViewChild } from '@angular/core';
import { EditListFacade } from '../../state/edit-list.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { DialogComponent } from '../../../_shared/components/dialog/dialog.component';

@Component({
  selector: 'app-cover-selection-dialog',
  templateUrl: './cover-selection-dialog.component.html',
  styleUrls: ['./cover-selection-dialog.component.scss']
})
export class CoverSelectionDialogComponent {
  private readonly editListFacade = inject(EditListFacade);

  @ViewChild(DialogComponent) dialog!: DialogComponent;

  readonly list = toSignal(this.editListFacade.list$);
  readonly selectedCoverIdx = signal(this.list()?.selectedCoverIdx ?? 0);

  closeDialog() {
    this.dialog.closeDialog();
  }

  openDialog() {
    this.selectedCoverIdx.set(this.list()?.selectedCoverIdx ?? 0);
    this.dialog.openDialog();
  }

  saveCover() {
    this.editListFacade.updateLocalList({ selectedCoverIdx: this.selectedCoverIdx() });
    this.closeDialog();
  }
}
